const getOSType = () => {
  if (process.client) {
    return window?.navigator.userAgent.split(' ')[1].match(/\w+/)?.[0]
  }
}
export const getSearchInputKey = () => {
  const osType = getOSType()
  if (osType === 'Macintosh') {
    return 'Cmd+K'
  }
  if (osType === 'Windows') {
    return 'Ctrl+K'
  }
}